module.exports = __webpack_public_path__ + "static/media/gucci-bloom-big.6e0124f7.png";